import { getBuildTimeFeatures } from './buildTimeConfig';

export const MENU_DEFINITIONS = [
  { id: 'dashboard', path: '/dashboard', labelKey: 'common.dashboard', descriptionKey: 'onboarding.dashboardDescription' },
  { id: 'surety', path: '/surety', labelKey: 'common.surety', descriptionKey: 'onboarding.suretyDescription' },
  { id: 'services', path: '/services', labelKey: 'common.services', descriptionKey: 'onboarding.servicesDescription' },
  { id: 'feedback', path: '/feedback', labelKey: 'common.feedback', descriptionKey: 'onboarding.feedbackDescription' },
  { id: 'profile', path: '/profile', labelKey: 'common.profile', descriptionKey: 'onboarding.profileDescription' },
  { id: 'offers', path: '/offers', labelKey: 'common.offers', descriptionKey: 'onboarding.offersDescription' },
];

const VALID_MENU_IDS = new Set(MENU_DEFINITIONS.map((item) => item.id));
const DEFAULT_MENU_IDS = MENU_DEFINITIONS.map((item) => item.id);

const buildEnabledMenuIds = () => {
  const features = getBuildTimeFeatures();
  const enabledMenuInput = Object.entries(features)
    .filter(([_, enabled]) => enabled)
    .map(([feature]) => feature);
  
  if (enabledMenuInput.length === 0) return DEFAULT_MENU_IDS;

  const filtered = enabledMenuInput.filter((id) => VALID_MENU_IDS.has(id));
  if (filtered.length > 0) return filtered;

  return ['dashboard'];
};

export const getEnabledMenuIds = () => buildEnabledMenuIds();

export const isMenuEnabled = (menuId) =>
  getEnabledMenuIds().includes(String(menuId || '').trim().toLowerCase());

export const getEnabledMenuDefinitions = () =>
  MENU_DEFINITIONS.filter((item) => getEnabledMenuIds().includes(item.id));

export const getDefaultAuthenticatedPath = () => getEnabledMenuDefinitions()[0]?.path || '/dashboard';
